export class SupportTicketHistoryDto {

  public readonly created!: Date;
  public readonly updated: Date | undefined;
  public readonly userName!: string;
  public readonly content!: string;
  public readonly support!: boolean;
  public readonly unknown!: boolean;

  constructor(init?: Partial<SupportTicketHistoryDto> | undefined) {
    Object.assign(this, init);
    if (init?.created) {
      this.created = new Date(init.created);
    }
    if (init?.updated) {
      this.updated = new Date(init.updated);
    }
  }
}
